import React from 'react';
import PropTypes from 'prop-types';
import ChevronUp from 'mdi-react/ChevronUpIcon';
import ChevronDown from 'mdi-react/ChevronDownIcon';

import * as S from './styles';

const ExpandButton = React.memo(({ expanded, onClick, title }) => (
  <S.ExpandWrapper type="button" aria-label={title} onClick={onClick}>
    <S.ExpandButton data-test="ExpandButton">
      {expanded ? <ChevronUp /> : <ChevronDown />}
    </S.ExpandButton>
  </S.ExpandWrapper>
));

ExpandButton.propTypes = {
  expanded: PropTypes.bool,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

ExpandButton.defaultProps = {
  expanded: false,
  title: undefined,
  onClick: () => {},
};

export default ExpandButton;
